import { yupResolver } from '@hookform/resolvers/yup';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { DialogContent, Button, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { saveOurEntityBank, getCurrencyList } from 'wisestep-api';
import { ControlledTextInput, WsSelect, WsDialog, WsButton, WsSelectObj } from 'wisestep-base';
import { object, string } from 'yup';

import { success, failed } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

const validationSchema = object().shape({
  bankName: string().required('Please provide Bank Name'),
  branchName: string().required('Please provide Branch Name'),
  bankCode: string().required('Please provide Bank Code'),
  bankAccountNumber: string().required('Please provide Account Number'),
  currency: string().required('Please select Currency'),
});

interface CreateOurEntityBankDialogProps {
  ourEntityId: string;
  openDialog: boolean;
  onCancel: () => void;
  onSave: (data) => void;
}

const CreateOurEntityBankDialog = ({
  ourEntityId,
  openDialog,
  onCancel,
  onSave,
}: CreateOurEntityBankDialogProps) => {
  const methods = useForm<any>({
    resolver: yupResolver(validationSchema),
  });

  const { handleSubmit } = methods;
  const setNotification = useNotificationStore((state) => state.setNotification);

  const [currencyList, setCurrencyList] = useState<WsSelectObj[]>([]);

  useEffect(() => {
    const getCurrencyData = async () => {
      const response = await getCurrencyList();
      setCurrencyList(
        response.data.map((currency) => ({
          label: currency?.symbol,
          value: currency?.id,
        }))
      );
    };
    getCurrencyData();
  }, []);

  const onSubmit = async (data) => {
    try {
      data.ourEntityId = ourEntityId;
      await saveOurEntityBank(data)
        .then((response) => {
          return response.data;
        })
        .then((response) => {
          data = response.data;
        });
      setNotification(success('Our Entity Bank saved successfully.'));
      onSave(data);
    } catch (err: any) {
      setNotification(failed('Failed to save Our Entity Bank Info , Please try again !!'));
    }
  };

  return (
    <WsDialog size="medium" openDialog={openDialog}>
      <DialogContent>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container py={1}>
              <Grid item p={1} sm={5.5}>
                <ControlledTextInput
                  name={`bankName`}
                  type="text"
                  fullWidth
                  label="Bank Name"
                  variant="outlined"
                  showMandatorySymbol={true}
                />
              </Grid>
              <Grid item p={1} sm={5.5}>
                <ControlledTextInput
                  name={`branchName`}
                  type="text"
                  fullWidth
                  label="Branch Name"
                  variant="outlined"
                  showMandatorySymbol={true}
                />
              </Grid>
              <Grid item p={1} sm={5.5}>
                <ControlledTextInput
                  name={`bankCode`}
                  type="text"
                  fullWidth
                  label="Bank Code"
                  variant="outlined"
                  showMandatorySymbol={true}
                />
              </Grid>
              <Grid item p={1} sm={5.5}>
                <ControlledTextInput
                  name={`bankAccountNumber`}
                  type="text"
                  fullWidth
                  label="Bank Account Number"
                  variant="outlined"
                  showMandatorySymbol={true}
                />
              </Grid>
              <Grid item p={1} sm={5.5}>
                <WsSelect
                  placeholder="Currency"
                  name={`currency`}
                  selectArray={currencyList}
                  size="small"
                />
              </Grid>
              <Grid item p={1} sm={5.5}>
                <ControlledTextInput
                  name={`iban`}
                  type="text"
                  fullWidth
                  label="International Bank Number"
                  variant="outlined"
                  showMandatorySymbol={true}
                />
              </Grid>
              <Grid item p={1} sm={5.5}>
                <ControlledTextInput
                  name={`swiftCode`}
                  type="text"
                  fullWidth
                  label="Swift Code"
                  variant="outlined"
                  showMandatorySymbol={true}
                />
              </Grid>
            </Grid>
            <Grid container py={1}>
              <Grid item p={1} sm={5.25} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button size="large" color="error" onClick={() => onCancel()}>
                  Cancel
                </Button>
              </Grid>
              <Grid item p={1} sm={5.25}>
                <WsButton
                  type="submit"
                  variant="contained"
                  size="medium"
                  startIcon={<AddOutlinedIcon />}
                >
                  Save
                </WsButton>
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      </DialogContent>
    </WsDialog>
  );
};

export default CreateOurEntityBankDialog;
